import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Loading from '../../../Dashboard/Components/Loading/Loading';

import { updateBreadcrumbs } from '../../../Dashboard/Actions/LayoutActions';

import { getList as getLessonsList, remove as removeLesson } from '../../Actions/LessonsActions';

import { LessonsList } from '../../Components';

class LessonsContainer extends Component {
  static propTypes = {
    children: PropTypes.node,
    breadcrumbs: PropTypes.array,
  };

  constructor() {
    super();
  }

  componentWillMount() {
    const breadcrumbs = this.getBreadcrumbs();
    this.props.updateBreadcrumbs(breadcrumbs);

    const meta = {};

    this.props.getLessonsList(meta);
  }

  getBreadcrumbs() {
    return [
      {
        path: '/dashboard',
        label: 'Dashboard',
      },
      {
        path: '/dashboard/lessons',
        label: 'Lessons',
      },
    ];
  }

  render() {
    const { list, loading } = this.props;
    return (
      <div className="container">
        {loading ? (
          <Loading />
        ) : (
          <LessonsList
            lessons={list}
            removeLesson={this.props.removeLesson}
            getLessonsList={this.props.getLessonsList}
          />
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    loading: state.lessons.getIn(['grid', 'loading']) || false,
    list: state.lessons.getIn(['grid', 'list']).toJS() || [],
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateBreadcrumbs,
        getLessonsList,
        removeLesson,
      },
      dispatch
    )
)(LessonsContainer);



// WEBPACK FOOTER //
// ./src/modules/Lessons/Containers/LessonsPage/LessonsPage.js